export const JioPixel = (cid) => {
    if (cid != null && cid != undefined) {
        fetch(`https://mercury-ck.jio.com/delivery/cn.php?cid=${cid}&level=1`, {
              method: "GET"
          })
    }
}